<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { formatNumber, globalCurrencyTag } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';

  export let showDiscountUp = true;

  export let data: any;

  const { primeEnabled, primeLevel } = getAppConfig();
  let primePrice = null;

  if (primeEnabled) {
    if (data?.isJoodDay) {
      primePrice = data?.joodDayPrice;
    } else {
      if (primeLevel === 'VIPPRIME') {
        primePrice = data?.vipPrimePrice;
      } else if (primeLevel === 'BASICPRIME') {
        primePrice = data?.basicPrimePrice;
      } else if (primeLevel === 'SMARTPRIME') {
        primePrice = data?.smartPrimePrice;
      }
    }
  }
</script>

<section class="product_price" class:showDiscountUp>
  <div class="jood-prime-price">
    <h5 class="sticky-price">
      <Text key="jood.price.with.currency" args={[globalCurrencyTag, formatNumber(primePrice)]} />
    </h5>
    <span class="vat-info"><Text key="extra.vatLable" /></span>
  </div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .jood-prime-price {
    align-items: baseline;
    display: flex;
    gap: 0.4rem;
    .sticky-price {
      font-size: 2.4rem;
      font-weight: 700;
      line-height: 2.6rem;
    }

    .vat-info {
      color: $neutral-dark-04;
      font-weight: 400;
      font-size: 10px;
      line-height: 11px;
    }
    .amount {
      font-weight: 700;
    }
  }
  .percent-discount {
    color: $primary-white;
    background-color: $functional-orange;
    padding: 4px 8px;
    border-radius: 5px;
    font-weight: 700;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    white-space: nowrap;
    max-width: max-content;
    margin-bottom: 5px;
    @include desktop-min-width {
      margin-bottom: 12px;
    }
  }
  .offer-options {
    color: $icon-only-icon-blue;
    margin-top: 6px;

    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
</style>
